<template>
  <el-container class="result">
    <el-header style="height:50px;padding: 15px 19px 0;background: #f7f7f7">
      <header-crunb :crumbList="crumbList" style="font-size:1rem;font-weight:700"></header-crunb>
    </el-header>
    <div class="container">
      <div class="but-top clerfix">
        <span> 搜索关键字 ： </span>
        <el-input
          @change="changeKeyWord"
          class="search-word"
          clearable
          v-model="searchKeyWord"
          size="small"
        ></el-input>
        <el-button
          style="background:#21caaa;color:#fff"
          class="fr but-up"
          size="small"
          @click="addPopResult"
        > 新增考试</el-button>
      </div>
      <div class="table-box">
        <el-table
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.9)"
          row-key="id"
          :data="tableData"
          stripe
          style="width: 100%"
          :header-cell-style="{background:'#EFEFEF'}"
        >
          <el-table-column
            prop="examName"
            label="考试名称"
          >
          </el-table-column>
          <el-table-column
            prop="schoolYear"
            label="学年"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="schoolTerm"
            width="100"
            label="学期"
          >
            <template slot-scope="{row}">
              {{row.schoolTerm =="1" ? "上学期":"下学期"}}
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="班级年级"
            align="center"
          >
            <template slot-scope="{row}">
              {{row.gradeName+(row.className||"")}}
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="className"
            label="年级"
          >
          </el-table-column> -->
          <el-table-column
            prop="createTime"
            label="上传时间"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="isOpen"
            label="发送给学生"
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isOpenFlag"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="(val)=>{changeOpen(scope.row.id,val)}"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                class="text-edit"
                @click="showDetilPop(scope.$index, scope.row)"
              >详情</el-button>
              <el-button
                type="text"
                @click="addPopResult(scope.$index, scope.row)"
              >编辑</el-button>
              <el-button
                type="text"
                class="text-del"
                @click="showDelPop(scope.$index, scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <pagination
        :pageObj="pageObj"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>

    </div>
    <!-- 删除的对话框 -->
    <popup-del
      :delVisible="delVisible"
      @close="closePopupDel"
    ></popup-del>
    <!-- 新增编辑考试-->
    <el-dialog
      class="add-pop pop-up"
      :visible.sync="uploadPop"
      :close-on-click-modal="false"
      :showClose="false"
      top="9%"
    >
      <template v-slot:title>
        <div class="add-title">{{examForm.id?"编辑":"新增"}}考试 </div>
      </template>
      <div>
        <div class="right-box clearfix">
          <div class="form-box">
            <el-form
              ref="form"
              :rules="upRules"
              :model="examForm"
              label-width="80px"
              class="up-form"
            >

              <el-form-item
                label="名称"
                prop="examName"
              >
                <el-input
                  class="input-wid"
                  placeholder="请输入"
                  v-model="examForm.examName"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="学年"
                prop="schoolYear"
              >
                <template>
                  <el-date-picker
                    placeholder="请选择"
                    v-model="examForm.schoolYear"
                    value-format="yyyy"
                    type="year"
                  >
                  </el-date-picker>
                </template>
              </el-form-item>
              <el-form-item
                label="学期"
                prop="schoolTerm"
              >
                <el-select
                  v-model="examForm.schoolTerm"
                  placeholder="请选择"
                >
                  <el-option
                    key="1"
                    label="上学期"
                    :value="1"
                  ></el-option>
                  <el-option
                    key="2"
                    label="下学期"
                    :value="2"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="年级班级"
                prop="classCode"
              >
                <el-select
                  v-model="examForm.classCode"
                  placeholder="请选择"
                >
                  <template v-for="i of userInfo.teacherInfoList">
                    <el-option
                      :key="i.classCode"
                      :label="i.gradeName+i.className"
                      :value="i.classCode"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="试卷分类"
                prop="examType"
              >
                <el-select
                  v-model="examForm.examType"
                  placeholder="请选择"
                >
                  <template v-for="i of examTypeOptions">
                    <el-option
                      :key="i.id"
                      :label="i.name"
                      :value="i.code"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item
                label="记分类型"
                prop="examResult"
              >
                <el-radio-group v-model="examForm.examResult">
                  <el-radio label="score">分数制</el-radio>
                  <el-radio label="rank">等第式（不显示分数）</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="科目"
                prop="disciplineList"
              >
                <template>
                  <el-select
                    v-model="examForm.disciplineList"
                    placeholder="请选择科目"
                    @change="changeDiscipline"
                    multiple
                  >
                    <el-option
                      v-for="i in disciplineOption"
                      :key="i.id"
                      :label="i.disciplineName"
                      :value="i.disciplineCode"
                    ></el-option>
                  </el-select>
                  <div
                    class="discipline-score clearfix"
                    v-if="examForm.examResult=='score'"
                  >
                    <div
                      class="socre-box fl"
                      v-for="(i,index) in disciplineScore"
                      :key="index"
                    >
                      <span>{{i.name}}：</span>
                      <el-input
                        size="small"
                        class="discipline-score-input"
                        placeholder="总分值"
                        type="number"
                        v-model="i.score"
                      ></el-input>
                    </div>

                  </div>
                </template>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <template v-slot:footer>
        <div class="dialog-footer">
          <el-button
            round
            @click="uploadPop=false"
            class="cle-btn"
            size="small"
          >取 消</el-button>
          <el-button
            round
            @click="subResult"
            type="primary"
            class="sub-btn"
            size="small"
          >确 定</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 考试详情 -->
    <el-dialog
      class="add-pop result-list-pop"
      :visible.sync="resultListPop"
      :close-on-click-modal="false"
      :showClose="false"
      top="4.4%"
    >
      <template v-slot:title>
        <div class="add-title">考试详情 </div>
      </template>
      <div>
        <div class="right-box clearfix">
          <div class="clearfix">
            <el-button
              class="fr"
              size="small"
              type="primary"
              @click="resultListPop=false"
            >返回</el-button>
          </div>

          <div class="unit1">
            <div class="tit clearfix">
              <div class="tit-left fl">
                <h2>{{this.curRow.examName}}</h2>
                <h3>{{this.curRow.gradeName}}|{{this.tableData2.length}}人考试|{{this.curRow.createTime}}</h3>
              </div>
              <div class="tit-right fr">
                <el-button
                  @click="downloadTpl"
                  size="small"
                  round
                  type="primary"
                > 下载导入模板 </el-button>
                <excel-upload
                  class="export-upload-class"
                  @selectLsit="excelSuccess"
                  :urlAction="exUrl"
                  :exData="exData"
                ></excel-upload>
                <el-button
                  round
                  type="primary"
                  size="small"
                  class="el-icon-upload2"
                  @click="exportExcel"
                > 导出成绩</el-button>
              </div>
            </div>
            <div class="box-table-inprt">
              <auto-table
                id="exportClassId"
                :tableType="tableType1"
                :tableData="tableData1"
                :tableLabel="tableLabel1"
              ></auto-table>
            </div>
          </div>
          <div class="unit1">
            <div class="tit clearfix">
              <div class="tit-left fl">
                <h2>学生得分详情</h2>
                <!-- <h3>一年级一般|32人考试|2021年10月12日10:18</h3> -->
              </div>
              <!-- <div class="tit-right fr">
                <el-button
                  round
                  type="primary"
                  size="small"
                  class="el-icon-chat-dot-round"
                > 发送给学生</el-button>
              </div> -->
            </div>
            <div class="box-table-inprt">
              <auto-table
                id="exportStuId"
                :tableType="tableType2"
                :tableData="tableData2"
                :tableLabel="tableLabel2"
              ></auto-table>
            </div>
          </div>
        </div>
      </div>

    </el-dialog>
  </el-container>
</template>

<script>
import HeaderCrunb from "@/components/HeaderCrunb.vue";
import PopupDel from "@/components/PopupDel.vue";
import Pagination from "@/components/Pagination.vue";
import AutoTable from "@/components/autoTable.vue";
import ExcelUpload from "@/components/upload/ExcelUpload.vue";
import { downloadExecl, downlaodHandler,handle_export } from "@/utils/index";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
export default {
  components: {
    HeaderCrunb,
    Pagination,
    PopupDel,
    ExcelUpload,
    AutoTable,
  },
  computed: {
    ...mapState(["userInfo", "activeLabelInfo"]),
    crumbList() {
      return [
        { path: "", name: "成绩报告", id: 1 },
        // { path: "", name: "一年级(1)班", id: 2 },
      ];
    },
    exData() {
      if (this.curRow) {
        return {
          schoolCode: this.curRow.schoolCode,
          examCode: this.curRow.examCode,
        };
      } else {
        return "";
      }
    },
  },
  data() {
    var validateDiscipline = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请选择科目"));
      } else {
        if (this.disciplineScore.length > 0) {
          if (this.examForm.examResult == "score") {
            this.disciplineScore.every((i) => i.score > 0)
              ? callback()
              : callback(new Error("请输入正确的分值"));
          } else {
            this.disciplineScore.every((i) => i.score == "A")
              ? callback()
              : callback(new Error("请输入正确的分值"));
          }
        } else {
          callback(new Error("请选择科目"));
        }
      }
    };
    return {
      searchKeyWord: "",
      pageObj: {
        current: 1,
        total: 50,
        size: 10,
      },
      tableData: [],
      curRow: "",
      //删除
      delVisible: false,
      //上传考试 弹框
      uploadPop: false,
      //生成考试单
      resultListPop: false,
      schoolYearOptions: [
        {
          id: 1,
          dicName: "因你那几报表",
          dicCode: 123,
        },
        {
          id: 2,
          dicName: "报表",
          dicCode: 1243,
        },
      ],
      disciplineOption: [], //学科

      examTypeOptions: [
        { name: "期中", code: 0 },
        { name: "期末", code: 1 },
        { name: "其它", code: 2 },
      ],
      disciplineScore: [],
      examForm: {
        examName: "",
        schoolYear: "",
        schoolTerm: null,
        examType: null,
        examResult: "score",
        disciplineList: [], //学科
        classCode: "",
      },
      upExamData: [{ stuCode: "1234560", stuName: "张三", china: "语文" }],
      upRules: {
        examName: [
          {
            required: true,
            message: "请输入",
            trigger: ["change", "blur"],
          },
        ],
        examType: [
          {
            required: true,
            message: "请选择试卷分类",
            trigger: ["change", "blur"],
          },
        ],
        schoolYear: [
          {
            required: true,
            message: "请选择学年",
            trigger: ["change", "blur"],
          },
        ],
        classCode: [
          {
            required: true,
            message: "请选择年级班级",
            trigger: ["change", "blur"],
          },
        ],
        schoolTerm: [
          {
            required: true,
            message: "请选择学期",
            trigger: ["change", "blur"],
          },
        ],
        examResult: [
          {
            required: true,
            message: "请选择",
            trigger: ["change", "blur"],
          },
        ],
        disciplineList: [
          {
            required: true,
            validator: validateDiscipline,
            trigger: ["change", "blur"],
          },
        ],
      },

      //导入
      exUrl: "/tree-web/back/exam/bathUserExamScore",

      //考试成绩分析
      tableType1: "", //等第，分值
      tableData1: [],
      tableLabel1: [],
      //学生成绩列表
      tableType2: "score",
      tableData2: [],
      tableLabel2: [],
    };
  },
  created() {
    this.selectLsit();
    this.selDisciplineOption();
  },
  methods: {
    async selectLsit(current, size) {
      let initForm = {
        examResult: "", //试卷考试分类，score：分值制，rank：等第制
        examType: "", //试卷分类：0：期中，1：期末，2：学科竞赛，3、毕业会考，4、月考
        keyword: this.searchKeyWord || "",
        pageNum: current || this.pageObj.current,
        pageSize: size || this.pageObj.size,
        schoolCode: this.userInfo.schoolCode,
        operatorId: this.userInfo.userId,
      };
      let { total, records } = await postJson(
        "/back/exam/getUserExamInfoList",
        initForm
      );
      records.forEach((i) => (i.isOpenFlag = i.isOpen == 1 ? true : false));
      this.tableData = records || [];
      this.pageObj.total = total;
    },
    changeKeyWord() {
      this.selectLsit(1, 10);
    },

    async selDisciplineOption() {
      this.disciplineOption = await postData(
        "/core/discipline/getDisciplinelList",
        {
          fieldCode: "",
          schoolCode: this.userInfo.schoolCode,
        }
      );
    },
    showDelPop(index, row) {
      this.curRow = row;
      this.delVisible = true;
    },
    // 删除弹框 关闭
    async closePopupDel(status) {
      try {
        !status && (this.delVisible = false);
        if (status) {
          await postData("/back/exam/deleteUserExamInfo", {
            id: this.curRow.id,
          });
          this.selectLsit(this.pageObj.current, this.pageObj.size),
            this.$message.success("删除成功");
          this.delVisible = false;
        }
      } catch (err) {
        console.log("err", err);
      }
    },

    changeDiscipline(codeList) {
      console.log("学科改变 改变下面的分值 codeList", codeList);
      if (codeList.length == 0) {
        this.disciplineScore = [];
      } else {
        let tplDisciplineScore = this.disciplineOption.filter((i) =>
          codeList.includes(i.disciplineCode)
        );
        this.disciplineScore = [];
        tplDisciplineScore.forEach((i) => {
          if (this.examForm.examResult == "score") {
            this.disciplineScore.push({
              name: i.disciplineName,
              code: i.disciplineCode,
              score: "100",
            });
          } else {
            this.disciplineScore.push({
              name: i.disciplineName,
              code: i.disciplineCode,
              score: "A",
            });
          }
        });
      }
    },
    //导出成绩
    exportExcel() {
      // downlaodHandler("#exportClassId","学生得分统计表");
      //downlaodHandler("#exportStuId","学生得分明细表");
      handle_export()
    },
    //下载模板
    async downloadTpl() {
      try {
        //模板下载
        this.$axios
          .get("/back/exam/downloadExamTemplate", {
            params: {
              examCode: this.curRow.examCode,
              schoolCode: this.curRow.schoolCode,
            },
            responseType: "blob",
          })
          .then((res) => {
            downloadExecl(res, "学生成绩导入模板");
          });
      } catch (err) {
        console.log("err", err);
      }
    },
    //导入成功
    excelSuccess() {
      this.selStuList();
      this.selClassList();
    },
    addPopResult(index, row) {
      if (row) {
        console.log("row", row);
        this.examForm = {
          examName: row.examName,
          schoolYear: row.schoolYear + "",
          schoolTerm: row.schoolTerm,
          examType: row.examType,
          examResult: row.examResult,
          disciplineList: JSON.parse(row.template).map((i) => i.code), //学科
          classCode: row.classCode,
          id: row.id,
        };
        this.changeDiscipline(this.examForm.disciplineList);
      } else {
        this.examForm = {
          examName: "",
          schoolYear: "",
          schoolTerm: null,
          examType: null,
          examResult: "score",
          disciplineList: [], //学科
          classCode: "",
        };
        this.disciplineScore = [];
        this.$refs.form && this.$refs.form.resetFields();
      }
      this.uploadPop = true;
    },
    //保存 考试
    async subResult() {
      try {
        await this.$refs.form.validate();
        let subForm = {
          grade: this.userInfo.teacherInfoList.find(
            (i) => i.classCode == this.examForm.classCode
          ).grade,
          gradeName: this.userInfo.teacherInfoList.find(
            (i) => i.classCode == this.examForm.classCode
          ).gradeName,
          className: this.userInfo.teacherInfoList.find(
            (i) => i.classCode == this.examForm.classCode
          ).className,
          classCode: this.examForm.classCode,
          examName: this.examForm.examName,
          examResult: this.examForm.examResult,
          examType: this.examForm.examType,
          schoolTerm: this.examForm.schoolTerm,
          schoolYear: this.examForm.schoolYear,
          template: JSON.stringify(this.disciplineScore),
          schoolCode: this.userInfo.schoolCode,
          operatorId: this.userInfo.userId,
          id: this.examForm.id || "",
        };
        await postJson("/back/exam/saveOrUpdateUserExamInfo", subForm);
        this.$message({ type: "success", message: "保存成功" });
        this.selectLsit();
        this.uploadPop = false;
      } catch (err) {
        console.log("err", err);
      }
    },
    async changeOpen(id, isOpen) {
      await postJson("/back/exam/updateUserExamInfoOpenStatus", {
        id: id,
        operatorId: this.userInfo.userId,
        status: isOpen ? 1 : 0,
      });
      this.selectLsit(this.pageObj.current, this.pageObj.size);
      this.$message.success("修改成功！");
    },
    //分页
    handleSizeChange(pageSize) {
      this.pageObj.size = pageSize;
      this.selectLsit(1, pageSize);
    },
    handleCurrentChange(curPage) {
      this.selectLsit(curPage);
    },

    async showDetilPop(index, row) {
      this.curRow = row;
      await this.selStuList();
      await this.selClassList();
      this.resultListPop = true;
    },
    //查询班级成绩分析
    async selClassList() {
      let classForm = {
        pageNum: 1,
        pageSize: -1,
        schoolCode: this.curRow.schoolCode,
        examCode: this.curRow.examCode,
        // studentId: "20210719154945Yl52",
        teacherId: this.userInfo.userId,
      };
      let { records } = await postJson(
        "/back/exam/getExamReportList",
        classForm
      );

      //分数制
      if (records[0].examResult == "score") {
        this.tableType1 = "score";
        this.tableData1 = [];
        this.tableLabel1 = [
          { align: "center", label: "", param: "scoreType", width: "200" },
        ];
        //满分
        let fullScore = JSON.parse(records[0].template);
        console.log("fullScore", fullScore);
        let tableDataFullObj = { scoreType: "满分" };
        fullScore.forEach((i) => {
          tableDataFullObj[i.code + "Score"] = i.score;
          tableDataFullObj[i.code + "Name"] = i.name;
          this.tableLabel1.push({
            align: "center",
            label: i.name,
            param: i.code + "Score",
          });
        });
        this.tableData1.push(tableDataFullObj);
        //平均分
        let avgScore = records[0].scoreList || [];
        let tableDataAvgObj = { scoreType: "平均分" };
        avgScore.forEach((i) => {
          tableDataAvgObj[i.disciplineCode + "Score"] = i.avgScore;
          tableDataAvgObj[i.disciplineCode + "Name"] = i.disciplineName;
        });
        this.tableData1.push(tableDataAvgObj);
        console.log("table1", this.tableData1);
        console.log("tableLabel1", this.tableLabel1);
      } else if (records[0].examResult == "rank") {
        //等第制
        this.tableType1 = "rank";
        this.tableData1 = records[0].scoreList || [];
      }
      return new Promise((resolve, reject) => {
        resolve("class-ok");
      });
    },
    //查询详情学生成绩列表
    async selStuList() {
      let stuForm = {
        examCode: this.curRow.examCode,
        pageNum: 1,
        pageSize: -1,
        schoolCode: this.curRow.schoolCode,
      };
      let { total, records } = await postJson(
        "/back/exam/getUserExamScoreList",
        stuForm
      );

      let stuAllList = records;
      let stuScoreList = [];
      let stuScoreLabel = [
        {
          align: "center",
          label: "姓名",
          param: "userName",
        },
        {
          align: "center",
          label: "学籍号",
          param: "xjh",
        },
      ];
      stuAllList.forEach((i) => {
        //label
        if (!stuScoreLabel.some((laI) => laI.label == i.disciplineName)) {
          stuScoreLabel.push({
            align: "center",
            label: i.disciplineName,
            param: i.disciplineCode + "Score",
          });
        }
        //tableData
        if (stuScoreList.some((stuI) => stuI.userId == i.userId)) {
          let existenceObj = stuScoreList.find(
            (existenceI) => existenceI.userId == i.userId
          );
          existenceObj[i.disciplineCode + "Name"] = i.disciplineName;
          existenceObj[i.disciplineCode + "Score"] = i.score;
          existenceObj.total = Number(i.score) + Number(existenceObj.total);
        } else {
          stuScoreList.push({
            userId: i.userId,
            userName: i.userName,
            xjh: i.xjh,
            [i.disciplineCode + "Name"]: i.disciplineName,
            [i.disciplineCode + "Score"]: i.score,
            total: i.score,
          });
        }
      });
      //等第
      if (
        !stuScoreList.some((i) => Number.isNaN(i.total)) &&
        stuScoreList.length > 0
      ) {
        stuScoreLabel.push({
          align: "center",
          label: "总分",
          param: "total",
        });
      }
      console.log("stuScoreList", stuScoreList);
      console.log("stuScoreLabel", stuScoreLabel);
      this.tableData2 = stuScoreList;
      this.tableLabel2 = stuScoreLabel;
      return new Promise((resolve, reject) => {
        resolve("stu-ok");
      });
    },
  },
  watch: {
    "examForm.examResult": {
      handler(val, old) {
        this.changeDiscipline(this.examForm.disciplineList);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.result {
  .container {
    padding: 20px;
    //border: 1px solid #000;
    background-color: white;
    .but-top {
      padding: 0px 10px;
      margin-bottom: 20px;
      span {
        font-size: 13px;
      }
      .search-word {
        width: 200px;
        margin-right: 20px;
      }
      .but-up {
        font-size: 13px;
      }
    }
    .table-box {
      //border: 1px solid rgb(155, 16, 16);
      .text-del {
        margin-left: 10px;
        color: @hong;
      }
      .text-edit {
        color: rgb(10, 6, 245);
      }
    }
  }
  //上传考试
  /deep/.add-pop.pop-up {
    .el-dialog {
      width: 200px;
      .el-dialog__body {
        padding: 0px 10px;
      }
      .right-box {
        padding: 10px 15px;
        width: 100%;
        .but-all {
          margin-bottom: 10px;
        }
        .form-box {
          padding: 0px 160px;
          margin-top: 10px;
          .discipline-score {
            .socre-box {
              margin-right: 10px;
              margin-top: 5px;
            }
            .discipline-score-input {
              width: 54px;
              .el-input__inner {
                padding: 1px 2px;
              }
            }
          }
          .up-form {
            .el-form-item {
              margin-bottom: 15px;
              .input-wid {
                width: 220px;
              }
            }
          }
        }
      }
      .sub-btn {
        width: 80px;
      }
    }
  }
  /deep/.add-pop.result-list-pop {
    .el-dialog {
      width: 80%;
      min-width: 900px;
      .el-dialog__body {
        padding: 0px 10px;
      }
      .right-box {
        padding: 10px 15px;
        width: 100%;
        min-height: 600px;
        // height: 700px;
        //border: 1px solid rgb(211, 40, 40);
        .unit1 {
          margin-bottom: 20px;
          .tit {
            //border: 1px solid #000;
            border-left: 5px solid @color;
            margin-top: 8px;
            padding: 3px 10px;
            .tit-left {
              //border: 1px solid #000;
              width: 45%;
              h2 {
                font-size: 16px;
              }
              h3 {
                color: @hui;
                font-size: 13px;
              }
            }
            .tit-right {
              // border: 1px solid #000;
              width: 50%;
              text-align: right;
            }
          }
          .box-table-inprt {
            margin-top: 10px;
            //border: 1px solid #000;
          }
        }
      }
    }
  }
}
</style>
